import { render, staticRenderFns } from "./PtSharedContentPage.vue?vue&type=template&id=36c76b32"
import script from "./PtSharedContentPage.vue?vue&type=script&lang=ts"
export * from "./PtSharedContentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports